import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import {
  FaChevronRight,
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import logo from "../../assets/images/logo.png";
import shape from "../../assets/images/team/dots-1.png";
import whatsapp from "../../assets/images/Home/whatsapp.png";
import { Col, Row } from "react-bootstrap";

const Footer = () => {
  useEffect(() => {
    footerdata();
  }, []);

  const [fooder, setfooder] = useState("");
  const [status, setstatus] = useState("");
  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      setstatus(res.data.status);
    } catch (error) {}
  };
  return (
    <footer>
      {status == 1 ? (
        <>
          <div className="footer_main py-60">
            <img src={shape} alt="shape" className="dots" loading="lazy"/>
            <div className="container">
              <Row>
                {/* Logo and Description */}
                <Col xl={4} lg={3} sm={12}>
                  <div className="footer_widget">
                    <Link to="/" className="footer_logo">
                      <img src={logo} alt="Logo" loading="lazy"/>
                    </Link>
                    <p className="description_text">{fooder.description}</p>
                  </div>
                </Col>

                {/* Quick Links */}
                <Col xl={2} lg={3} sm={6}>
                  <div className="footer_widget">
                    <h5 className="footer_heading mb-16">Quick Links</h5>
                    <ul className="unstyled list">
                      <li>
                        <Link to="courses">
                          <FaChevronRight /> Courses
                        </Link>
                      </li>
                      <li>
                        <Link to="/gallery">
                          <FaChevronRight /> Gallery
                        </Link>
                      </li>
                      <li>
                        <Link to="/blog">
                          <FaChevronRight /> Blog
                        </Link>
                      </li>
                      <li>
                        <Link to="/Previous-Papers">
                          <FaChevronRight /> Previous Papers
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Col>

                {/* Information */}
                <Col xl={2} lg={3} sm={6}>
                  <div className="footer_widget">
                    <h5 className="footer_heading mb-16">Information</h5>
                    <ul className="unstyled list">
                      {/* <li>
                        <Link to="/login">
                          <FaChevronRight /> Login
                        </Link>
                      </li>
                      <li>
                        <Link to="/register">
                          <FaChevronRight /> Register
                        </Link>
                      </li> */}
                      <li>
                        <Link to="/About-us">
                          <FaChevronRight />
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact-us">
                          <FaChevronRight /> Contact Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">
                          <FaChevronRight /> Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms">
                          <FaChevronRight /> Terms & Condition
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Col>

                {/* Contact Info */}
                <Col xl={4} lg={3} md={12} sm={12}>
                  <div className="footer_widget">
                    <h5 className="footer_heading mb-16">Contact Us</h5>
                    <ul className="unstyled list">
                      <li className="mb-16">
                        <div>
                          <FaMapMarkerAlt />
                        </div>{" "}
                        {fooder.address}
                      </li>
                      <li className="mb-16">
                        <Link to={`mailto:${fooder.email_id}`}>
                          <FaEnvelope /> {fooder.email_id}
                        </Link>
                      </li>
                      <li>
                        <Link to={`tel:${fooder.support1_number}`}>
                          <FaPhoneAlt />
                          +91 {fooder.support1_number}
                        </Link>
                      </li>
                      <li>
                        <Link to={`tel:${fooder.mobile_number}`}>
                          <FaPhoneAlt />
                          +91 {fooder.mobile_number}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>

              {/* Social & Newsletter */}
              <div className="bottom-row">
                <ul className="unstyled social_icons_list">
                  <li>
                    <a
                      href={fooder.insta_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Instagram"
                    >
                      <FaInstagram />
                    </a>
                  </li>
                  <li>
                    <a
                      href={fooder.facebook_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                    >
                      <FaFacebookF />
                    </a>
                  </li>
                  <li>
                    <a
                      href={fooder.youtube_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Youtube"
                    >
                      <FaYoutube />
                    </a>
                  </li>
                  <li>
                    <a
                      href={fooder.whatsApp_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Whatsapp"
                    >
                      <FaWhatsapp />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="copyright_row">
            <p>
              @ Copyright {new Date().getFullYear()}{" "}
              <Link to="https://theexcellers.com">The Excellers</Link> All
              Rights Reserved.
            </p>
          </div>
        </>
      ) : (
        ""
      )}

      <div className="whatsappicon fixeditems">
        <Link
          rel="noreferrer"
          to={`https://api.whatsapp.com/send?phone=91${fooder.whatsapp_number}
 `}
          target="_blank"
        >
          <img alt="whatsapp" src={whatsapp} />
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
